module.exports = __webpack_public_path__ + "img/30.70f29619.png";